import { render } from "./CarouselComponent.vue?vue&type=template&id=36f30ce7&scoped=true"
import script from "./CarouselComponent.vue?vue&type=script&lang=js"
export * from "./CarouselComponent.vue?vue&type=script&lang=js"

import "./CarouselComponent.vue?vue&type=style&index=0&id=36f30ce7&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f30ce7"]])

export default __exports__